import { useState, useEffect } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { api } from "source/registrations/api/client"
import { PAYMENT_URLS } from "source/payments/utils"
import { useStripeAppearance } from "source/shared/hooks/useStripeAppearance"

const paymentElementOptions = {
  layout: {
    type: "tabs",
    defaultCollapsed: false,
  },
  paymentMethodOrder: ["card"],
  wallets: {
    applePay: "never",
    googlePay: "never",
  },
}

export function useStripeConfig({ publishable_key, account_identifier }) {
  const [stripe, setStripe] = useState(null)
  const [clientSecret, setClientSecret] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const appearance = useStripeAppearance()

  useEffect(() => {
    const fetchStripe = async () => {
      try {
        const stripeResponse = await loadStripe(publishable_key, {
          stripeAccount: account_identifier,
        })
        setStripe(stripeResponse)

        const { data } = await api.post(PAYMENT_URLS.SETUP_INTENT)
        setClientSecret(data?.clientSecret)

        setError(null)
      } catch (error) {
        setError(error)
        setStripe(null)
        setClientSecret(null)
      } finally {
        setLoading(false)
      }
    }

    fetchStripe()
  }, [publishable_key, account_identifier])

  return {
    stripe,
    stripeOptions: { clientSecret, appearance },
    paymentElementOptions,
    loading,
    error,
  }
}
